<script>
import Layout from '../../layouts/auth'

import appConfig from '@/app.config'
import { email, required, minLength, maxLength } from 'vuelidate/lib/validators'
import { LOGIN, CREATE_USER_METADATA } from '@/services/api/auth'
import { GetAddressData } from '@/services/api/map'
import moment from 'moment'
moment.locale('id')
import Swal from 'sweetalert2'
import { MixPanel } from '@/mixin/mixpanel'
import i18n from '../../../i18n'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import parser from 'ua-parser-js'
import axios from 'axios'
import { getAddress, getGeolocation } from '@/services/api/geolocation'
import { GET_FCM_TOKEN, UNREGISTER_FCM_TOKEN } from '@/services/api/fcm'
import { unregisterFCMServiceWorkers } from '@/helpers/unregister-service-workers'
/**
 * Login component
 */
export default {
  page: {
    title: 'Login',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  mixins: [Helper],
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      submitted: false,
      authError: null,
      tryingToLogIn: false,

      mode: this.$store.state.config.mode,
      host: window.location.host,

      // This variabel is replaced by dynamic asset from Vuex
      backgroundLogin: {
        backgroundImage: !this.$store.state.whitelabel.checkDomainShow
          ? `url('/img/login.jpg')`
          : '',
      },
      language: i18n.locale,

      userMetadata: {
        email: null,
        userRole: null,
        location: null,
        ipAddress: '',
        application: '',
        os: '',
      },
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
  },
  created() {
    this.setUserMetaData()
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', i18n.locale)
    }
    i18n.locale = localStorage.getItem('language')
    this.language = localStorage.getItem('language')
  },
  async mounted() {
    MixPanel.methods.reset()
    MixPanel.methods.unRegister()
    this.adjustImageSize()
    await this.setUserMetaData()
    await this.setUserLocation()

    navigator.serviceWorker.getRegistrations()?.then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister()
      }
      if (registrations.length == 0) {
        return
      }
      window.location.reload()
    })
  },
  methods: {
    // Try to log the user in with the username
    // and password they provided.
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    async clearPreviousSubscriptions() {
      const [lastFCMToken] = await Promise.all([
        this.$apollo.query({
          query: GET_FCM_TOKEN,
        }),
        unregisterFCMServiceWorkers(navigator),
      ])

      const { data } = lastFCMToken
      const token = data?.getFCMToken?.getFCMToken?.fcmToken

      if (token) {
        try {
          await this.$apollo.mutate({
            mutation: UNREGISTER_FCM_TOKEN,
            variables: {
              input: {
                registrationToken: token,
                platform: 'web',
              },
            },
          })
        } catch (error) {
          // Ignore error
        }
      }
    },
    tryToLogIn() {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === 'firebase') {
          this.tryingToLogIn = true
          // Reset the authError if it existed.
          this.authError = null
          return (
            this.logIn({
              email: this.email,
              password: this.password,
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToLogIn = false
                // Redirect to the originally requested page, or to the home page
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: 'default',
                  }
                )
              })
              .catch((error) => {
                this.tryingToLogIn = false
                this.authError = error ? error : ''
              })
          )
        } else if (process.env.VUE_APP_DEFAULT_AUTH === 'authapi') {
          const input = {
            email: this.email,
            password: this.password,
            timezoneOffset: new Date().getTimezoneOffset(),
          }

          this.$apollo
            .mutate({
              mutation: LOGIN,
              variables: {
                input: input,
              },
            })
            .then(async (response) => {
              if (response.data.login.isSuccessful) {
                localStorage.removeItem('fcmToken')
                localStorage.removeItem('lastTokenTime')
                // First case if domain same as env in case for main domain
                if (response.data.login.data.canLogin) {
                  localStorage.removeItem('activePopups')
                  localStorage.removeItem('ctPopups')
                  localStorage.removeItem('notification-filters')
                  // Store user's metadata
                  // TODO: This ain't workin'
                  // this.createUserMetaData(response.data.login.data.resource)

                  // Call the clear function
                  if (this.getFeatureFlagValue('fcmTopicDeliveries')) {
                    await this.clearPreviousSubscriptions()
                  }

                  //  Check if user canLogin meaning has no payment due
                  if (
                    window.location.host === process.env.VUE_APP_MAIN_DOMAIN &&
                    this.mode == 'production'
                  ) {
                    localStorage.setItem('domainName', `${response.data.login.data.domainName}`)
                    // Set 12 Hours Redirect expired
                    localStorage.setItem(
                      'domainNameExpired',
                      moment(new Date()).add(12, 'hours').valueOf()
                    )
                    localStorage.setItem('payload', response.data.login.data.payload)
                    window.location.href = `${window.location.protocol}//${response.data.login.data.domainName}/authenticate/${response.data.login.data.resource}`
                    return
                  } else if (
                    window.location.host === response.data.login.data.domainName ||
                    this.mode != 'production'
                  ) {
                    if (response.data.login.data.canLogin) {
                      localStorage.setItem('domainName', `${response.data.login.data.domainName}`)
                      localStorage.setItem('payload', response.data.login.data.payload)
                      window.location.href = `${window.location.protocol}//${window.location.host}/authenticate/${response.data.login.data.resource}`
                      return
                    }
                  } else {
                    response.data.login.message = this.$t('login.text.invalid')
                    this.$mcToast.warning(response.data.login.message)
                  }
                } else {
                  // Check if user login in subdomain or in develop env
                  return Swal.fire({
                    title: this.$t('login.text.unableToAccess'),
                    text: this.$t('login.text.paymentNeeded'),
                    imageUrl: require(`@/assets/images/alert-report-danger.png`),
                    showCloseButton: true,
                    showConfirmButton: false,
                  })
                }
              } else {
                this.$mcToast.warning(response.data.login.message)
              }
            })
        }
      }
    },
    async setUserMetaData() {
      // Get application & os data from userAgent parser
      let clientData = parser(navigator.userAgent)
      this.userMetadata.application = clientData.browser.name
      this.userMetadata.os = clientData.os.name

      try {
        // Hit APIs to get extra informations
        const [ipFetch] = await Promise.all([axios.get('https://api.ipify.org?format=json')])
        this.userMetadata.ipAddress = ipFetch.data.ip
      } catch (error) {
        console.log(error)
      }
    },
    async createUserMetaData(resource) {
      try {
        await this.$apollo.mutate({
          context: {
            headers: {
              Authorization: `Bearer ${resource}`,
            },
          },
          mutation: CREATE_USER_METADATA,
          variables: { input: this.userMetadata },
        })
      } catch (error) {
        console.error(error)
      }
    },

    async setUserLocation() {
      let lat = 0,
        lon = 0
      // Get client location data
      const fetchLatLng = (resolve) =>
        navigator.geolocation.getCurrentPosition((data) => {
          lat = data.coords.latitude
          lon = data.coords.longitude
          resolve(true)
        })

      const executeLocFetch = new Promise((resolve) => {
        fetchLatLng(resolve)
      })

      await executeLocFetch

      try {
        // Hit APIs to get extra informations
        const useCache = this.isUsingCache()
        if (useCache) {
          const address = await getGeolocation({ lat, lon })
          this.userMetadata.location = getAddress(address, lat, lon)?.name
        } else {
          const addressData = await GetAddressData(lat, lon)
          this.userMetadata.location = addressData.display_name
        }
      } catch (err) {
        console.log(err)
      }
    },
    setLanguage(language) {
      this.language = language
      i18n.locale = language
      localStorage.setItem('language', i18n.locale)
      localStorage.removeItem('dashboard-config')
      localStorage.removeItem('notification-popup')
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },
  },
}
</script>
<style>
.mc-auth__banner-gray {
  background-color: #aeaeae;
}
</style>
<template>
  <Layout>
    <div class="row">
      <div
        class="col-md-8 col-lg-8 col-xl-9 mc-auth__banner"
        :class="{ 'mc-auth__banner-gray': $store.state.whitelabel.checkDomainShow }"
        :style="{
          backgroundImage: !$store.state.whitelabel.checkDomainShow
            ? `url('${getAsset('banner', 'login')}')`
            : '',
        }"
      ></div>
      <div class="col-md-4 col-lg-4 col-xl-3 mc-auth__form">
        <div class="mc-auth__logo mt-5">
          <h1>
            <router-link to="/">
              <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogo" />
            </router-link>
          </h1>
        </div>
        <div class="mc-auth__form-wrapper">
          <p class="mc-auth__label">{{ $t('login.text.loginToAcc') }}</p>

          <b-form class="mc-auth__form-wrapper-deep" @submit.prevent="tryToLogIn">
            <div v-if="notification.message" :class="'alert ' + notification.type">
              {{ notification.message }}
            </div>

            <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="email"
                type="text"
                placeholder="Email"
                :class="{
                  'is-invalid': submitted && $v.email.$error,
                }"
              ></b-form-input>

              <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                <span v-if="!$v.email.required">{{ $t('login.text.emailEmpty') }}</span>
                <span v-if="!$v.email.email">{{ $t('login.text.invalidEmailFormat') }}</span>
              </div>
            </b-form-group>

            <b-form-group class="mb-2 form-password" id="input-group-2" label-for="input-2">
              <b-form-input
                v-if="showPassword"
                id="input-2"
                v-model="password"
                type="text"
                :placeholder="$t('login.text.password')"
                :class="{
                  'is-invalid': submitted && $v.password.$error,
                }"
              ></b-form-input>
              <b-form-input
                v-else
                id="input-2"
                v-model="password"
                type="password"
                :placeholder="$t('login.text.password')"
                :class="{
                  'is-invalid': submitted && $v.password.$error,
                }"
              ></b-form-input>
              <i
                @click="togglePassword"
                class="mc-fa-password"
                :class="{
                  'icon-outline_eye': showPassword,
                  'icon-outline_eye-off-2': !showPassword,
                }"
              ></i>
              <div v-if="submitted && $v.password.$error" class="invalid-feedback">
                <span v-if="!$v.password.required">{{ $t('login.text.passwordEmpty') }}</span>
                <span v-if="!$v.password.minLength">{{ $t('login.text.minimumPassword') }}</span>
                <span v-if="!$v.password.maxLength">{{ $t('login.text.maximumPassword') }}</span>
              </div>
            </b-form-group>

            <b-form-group class="form-check">
              <b-form-checkbox
                id="checkbox-1"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
                v-if="mode == 'development'"
              >
                {{ $t('login.text.remember') }}
              </b-form-checkbox>

              <span class="mc-auth__flag" @click="setLanguage('en')">
                <img
                  src="@/assets/images/flags/US - border.png"
                  alt
                  v-if="$store.state.config.bilingual && language === 'id'"
                />
              </span>
              <span class="mc-auth__flag" @click="setLanguage('id')">
                <img
                  src="@/assets/images/flags/ID - border.png"
                  alt
                  v-if="$store.state.config.bilingual && language === 'en'"
                />
              </span>
            </b-form-group>

            <div class="mt-5 d-grid">
              <b-button type="submit" variant="primary" class="btn-block">{{
                $t('login.text.login')
              }}</b-button>
              <a
                class="text-primary d-block text-center mt-3"
                v-if="!$store.state.whitelabel.checkDomainShow"
                @click="$router.push({ name: 'Forgot Password' })"
                >{{ $t('login.text.forgot') }}</a
              >
            </div>

            <b-alert show variant="warning" v-if="mode == 'development'" class="mt-3">{{
              $t('login.text.development')
            }}</b-alert>
            <b-alert show variant="warning" v-else-if="mode == 'staging'" class="mt-3">{{
              $t('login.text.staging')
            }}</b-alert>
          </b-form>
        </div>
        <div class="mc-auth__copyright" v-if="!$store.state.whitelabel.checkDomainShow">
          <span
            :hidden="
              getAsset('copyrightLogo', 'general') == null ||
              getAsset('copyrightLogo', 'general') == ''
            "
            >{{ $t('login.text.presented') }}
            <img
              :src="getAsset('copyrightLogo', 'general')"
              alt
              class="ms-2"
              ref="imgCopyrightLogo"
          /></span>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
